



























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ParkingCounter } from "@/common/parkingTypes";
import { PendingOperationWrapper } from "@/utils/pendingOperationWrapper";
import parkingRepository from "@/data/parkingRepository";

@Component
export default class ParkingInfo extends Vue {
  @Prop() parking: ParkingCounter;

  editMode = false;
  operation1 = new PendingOperationWrapper();
  operation2 = new PendingOperationWrapper();
  newEmpty = 0;
  newTotal = 0;

  enableEdit() {
    this.editMode = true;
    this.newEmpty = this.parking.empty;
    this.newTotal = this.parking.total;
    this.operation1.clear();
    this.operation2.clear();
  }

  cancel() {
    this.editMode = false;
  }

  applyNewEmpty() {
    if (this.operation1.pending) return;

    const newInside = this.parking.total - this.newEmpty;
    this.operation1.handle(
      parkingRepository
        .updateInsideCount(this.parking.id, newInside)
        .then(res => {
          this.editMode = false;
        })
    );
  }

  applyNewTotal() {
    if (this.operation2.pending) return;

    this.operation2.handle(
      parkingRepository
        .updateTotalCount(this.parking.id, this.newTotal)
        .then(res => {
          this.editMode = false;
        })
    );
  }
}
